"use client";

import {
  Accordion,
  AccordionItem as ShadcnAccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@sendsprint/ui-react/shadcn/accordion";
import { AccordionItemProps } from "./accordionItem";

interface Props {
  dropdownItems: AccordionItemProps[];
}

const AccordionList = ({ dropdownItems }: Props) => {
  return (
    <Accordion type="single" collapsible defaultValue="item-0">
      {dropdownItems.map((item, index) => (
        <ShadcnAccordionItem
          key={index}
          value={`item-${index}`}
          className="ss:border-neutral-200"
        >
          <AccordionTrigger className="ss:text-left ss:py-6 ss:text-[16px] ss:border-neutral-300 ss:md:text-[20px] ss:font-medium">
            {item.title}
          </AccordionTrigger>
          <AccordionContent className="ss:pb-6">
            {item.content}
          </AccordionContent>
        </ShadcnAccordionItem>
      ))}
    </Accordion>
  );
};

export default AccordionList;
